import { render, staticRenderFns } from "./IMTableHeader.vue?vue&type=template&id=6317e852&scoped=true&"
import script from "./IMTableHeader.vue?vue&type=script&lang=js&"
export * from "./IMTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./IMTableHeader.vue?vue&type=style&index=0&id=6317e852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6317e852",
  null
  
)

export default component.exports